export interface Bank {
  codeName: string;
  colorCode: string | null;
  id: number;
  isFunder: boolean;
  name: string;
  slug: string;
}

export interface Origin {
  generated: string[];
  received: string[];
}

export interface MimeType {
  extensions: string[];
  mimeTypes: string[];
}

export interface DocumentType {
  code: string | null;
  helpText: string | null;
  id: number;
  name: string;
  displayName: string | null;
  requestablePortal: boolean;
  slug: string;
  uploadedDocumentsCount: number;
}

export interface DocumentTypeGroup {
  documentTypes: DocumentType[];
  id: number;
  name: string;
  portalPosition: number;
  position: number;
  slug: string;
}

export interface MlDecision {
  createdAt: string;
  guessedDocumentType: DocumentType;
  id: number;
  mlConfidencePercentage: number;
  state: string;
  updatedAt: string | null;
}

export enum DocumentState {
  Uploaded = 'uploaded',
  Classified = 'classified',
  ExtractionStarted = 'extraction_started',
  Extracted = 'extracted',
  ExtractionFailed = 'extraction_failed',
}

export type IaExtractionStatus = 'pending' | 'accepted' | 'rejected';
export type IaExtractionEntityType = 'credit' | 'income' | 'charge' | 'bank_account';

export const IA_EXTRACTION_ENTITY_LABELS: Record<IaExtractionEntityType, string> = {
  credit: 'crédit',
  income: 'revenu',
  charge: 'charge',
  bank_account: 'compte bancaire',
};

export interface ExtractionDecision {
  id: number;
  status: IaExtractionStatus | null;
  extractedEntityType: IaExtractionEntityType | null;
  extractedEntityId: number | null;
}

export interface Document {
  id: number;
  idExternal: string | null;
  name: string;
  nameExternal: string | null;
  originalName: string;
  fullName: string;
  fullOriginalName: string;
  origin: string;
  previewPath: string;
  viewPath: string;
  downloadPath: string;
  fullPath: string;
  extension: string;
  documentType: DocumentType;
  banks: Bank[];
  categoryExternal: string | null;
  mlDecisions: MlDecision[];
  extractionDecisionStatuses?: Record<number, IaExtractionStatus | null>;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  gdprDeletedAt?: string | null;
  permissions: string[];
  ownerExternal: string | null;
  availableForExtraction?: boolean;
  extractable?: boolean;
  analysisStarted?: boolean;
  state?: DocumentState | null;
  iaData?: boolean;
  detectedCredit?: boolean;
  extractionOcrScore?: number | null;
  documentQuality?: string | null;
}

export interface TreeTableDocument extends Document {
  key: string;
  data: Document;
  children: TreeTableDocument[] | null;
  additionalData?: string;
}
